var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specs"},[_c('ul',_vm._l((_vm.product.specs),function(spec){return _c('li',{key:spec.label},[_c('strong',[_vm._v(_vm._s(spec.label))]),_c('span',[_vm._v(_vm._s(spec.value))])])}),0),_c('strong',{staticClass:"price"},[_vm._v(_vm._s(_vm.product.price))])])
}
var staticRenderFns = []

export { render, staticRenderFns }